import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5901e85d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  style: {"color":"#607D8B","margin-bottom":"0","font-weight":"400"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"margin-bottom":"0","color":"#607D8B"} }, "Create account", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Please create an account to send an application.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = ["onSubmit"]
const _hoisted_10 = {
  class: "p-input-icon-left login",
  style: {"margin-bottom":"1em"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1))
const _hoisted_12 = {
  class: "p-input-icon-left",
  style: {"margin-bottom":"1em"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-phone" }, null, -1))
const _hoisted_14 = {
  class: "p-input-icon-left",
  style: {"margin-bottom":"1em"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar" }, null, -1))
const _hoisted_16 = {
  class: "p-input-icon-left",
  style: {"margin-bottom":"1em"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope" }, null, -1))
const _hoisted_18 = {
  class: "p-input-icon-left password",
  style: {"margin-bottom":"1em"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-lock" }, null, -1))
const _hoisted_20 = { class: "p-input-icon-left password" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-lock" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Already have an account? ")

import {computed, onMounted, ref} from "vue";
import Message from "primevue/message";
import router from "@/router/router";
import {createNewUser, getJobListing} from "@/model/api-no-auth";
import {firebaseSignIn} from "@/model/firebase";
import {JobListing} from "@/types/shared";


export default /*#__PURE__*/_defineComponent({
  props: {
  redirect: {
    required: false,
    type: String
  },
},
  setup(__props) {

const props = __props

const jobListing = ref<JobListing|undefined>(undefined)

const email = ref('')
const name = ref('')
const phoneNumber = ref('')
const birthYear = ref<number|undefined>(undefined)

const password1 = ref('')
const password2 = ref('')
const error = ref('')
const loading = ref(false)





const goToLogin = () => {
  router.push('/login/'+props.redirect)
}

onMounted(async () => {
  const id = jobListingId.value
  if (id) {
    jobListing.value = await getJobListing(id)
  }
})

const jobListingId = computed(() => {
  if (!props.redirect) return
  const jobId = props.redirect.split('l/')
  if (jobId.length > 1) return jobId[1]
  return undefined
})

const createUser = async () => {
  try {
    if (!name.value) {
      error.value = "Name cannot be empty."
      return
    }
    if (!phoneNumber.value) {
      error.value = "Phone number cannot be empty."
      return
    }
    if (!birthYear.value) {
      error.value = "Birth year cannot be empty."
      return
    }
    if (!email.value) {
      error.value = "E-mail cannot be empty."
      return
    }
    if (!password1.value) {
      error.value = "Password cannot be empty."
      return
    }
    if (password1.value !== password2.value) {
      error.value = "Passwords does not match."
      return
    }
    if (password1.value.length < 6) {
      error.value = "Password must be at least 6 characters."
    return
  }
    const newEmail = email.value
    const newPassword = password1.value
    const errorMessage = await createNewUser(name.value, email.value, password1.value, phoneNumber.value, birthYear.value)
    if (!errorMessage) {
      await firebaseSignIn(newEmail, newPassword)
      if (props.redirect) {
        await router.push('/'+props.redirect)
      } else {
        await router.push('/')
      }

    } else {
      error.value = errorMessage
    }
  } catch(err) {
    console.log(err)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (jobListing.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (jobListing.value.logoURL)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: jobListing.value.logoURL,
                alt: "",
                style: {"width":"7em","margin-top":"1.5em"}
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (jobListing.value)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(jobListing.value.title), 1))
      : _createCommentVNode("", true),
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _createElementVNode("form", {
      onSubmit: _withModifiers(createUser, ["prevent"]),
      style: {"align-items":"center"}
    }, [
      _createElementVNode("span", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_InputText, {
          modelValue: name.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
          type: "name",
          placeholder: "Full name",
          class: "input"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("span", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_InputText, {
          modelValue: phoneNumber.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phoneNumber).value = $event)),
          type: "phone",
          placeholder: "Telephone number",
          class: "input"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("span", _hoisted_14, [
        _hoisted_15,
        _createVNode(_component_InputText, {
          modelValue: birthYear.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((birthYear).value = $event)),
          type: "number",
          placeholder: "Birth year",
          class: "input"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("span", _hoisted_16, [
        _hoisted_17,
        _createVNode(_component_InputText, {
          modelValue: email.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((email).value = $event)),
          type: "email",
          placeholder: "E-mail",
          class: "input"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("span", _hoisted_18, [
        _hoisted_19,
        _createVNode(_component_InputText, {
          modelValue: password1.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((password1).value = $event)),
          type: "password",
          placeholder: "Password",
          class: "input"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("span", _hoisted_20, [
        _hoisted_21,
        _createVNode(_component_InputText, {
          modelValue: password2.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((password2).value = $event)),
          type: "password",
          placeholder: "Confirm password",
          class: "input"
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_22,
      _createVNode(_component_Button, {
        type: "submit",
        label: "Continue",
        class: "p-button-secondary",
        style: {"width":"14em"}
      }),
      _createElementVNode("span", { style: {"margin-top":"3em"} }, [
        _createElementVNode("i", null, [
          _hoisted_23,
          _createElementVNode("b", {
            onClick: goToLogin,
            style: {"cursor":"pointer","color":"#607D8B"}
          }, "Sign in")
        ])
      ])
    ], 40, _hoisted_9),
    (error.value)
      ? (_openBlock(), _createBlock(_unref(Message), {
          key: 2,
          class: "mb-3",
          severity: "error",
          closable: false
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(error.value), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})